import React, { Component } from "react";
import { sessionManager } from '../core/SessionManager';
import Login from "../pages/Login/Login";
import { routerConfigList, routerlist } from './PortalRoutes';
import { Redirect, Route } from 'react-router-dom';
import ForgetPwd from "../pages/Login/ForgetPwd";
import ChangeMobilePwd from '../pages/Login/ChangeMobilePwd';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import SuccessPage from '../pages/Settings/ChangeSuccess';

class PortalAuth extends Component {
    render() {
        const { location } = this.props;
        const { pathname } = location;
        const isLogin = sessionManager.getToken() && sessionManager.getUserInfo();
        const routerConfig = routerConfigList.concat(routerlist);

        const targetRouterConfig = routerConfig.find(
            (item) => {
                return item.path.replace(/\s*/g, "") === pathname
            }
        );
        if (isLogin) {
            if (pathname === "/") {
                return <Redirect to="/page/home" />;
            } else {
                if (targetRouterConfig) {
                    return <div>
                        {routerConfigList.map((data, index) => {
                            return <Route path={data.path} key={index} component={data.component} />
                        })}
                    </div>
                } else {
                    return <Redirect to="/page/home" />;
                }
            }
        } else if (pathname === "/forgetPwd") {
            return <Route component={ForgetPwd} />
        } else if (pathname === "/changeMobilePwd") {
            return <Route component={ChangeMobilePwd} />
        } else if (pathname === "/success") {
            return <Route component={SuccessPage} />
        } else if (pathname === "/error") {
            return <Route component={ErrorPage} />
        } else {
            return <Route component={Login} />
        }
    }
}
export default PortalAuth;